<template>
  <div>
    <div class="message_wrap">
      <el-row>
        <el-col :span="12" :offset="6">
          <div class="title-en">MESSAGE</div>
          <div class="title">在线留言</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" :offset="4">
          <span class="my-label">姓名:</span>
          <div class="my-input">
            <el-input v-model="form.name"></el-input>
          </div>
          <span class="star">*必填</span>
        </el-col>
        <el-col :span="8">
          <span class="my-label">电话:</span>
          <div class="my-input">
            <el-input v-model="form.phone"></el-input>
          </div>
          <span class="star">*必填</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" :offset="4">
          <span class="my-label">邮箱:</span>
          <div class="my-input">
            <el-input v-model="form.email"></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <span class="my-label">QQ:</span>
          <div class="my-input">
            <el-input v-model="form.qq"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" :offset="4" style="display: flex;">
          <span class="my-label">留言:</span>
          <div class="my-input" style="width: calc(100% - 125px);margin-left: 4px;margin-bottom: 20px;">
            <el-input type="textarea" :rows="3" v-model="form.content"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" :offset="6" style="text-align: center; margin-bottom: 20px;">
          <el-button type="primary" style="width: 120px;" v-on:click="postMessage">提交</el-button>
        </el-col>
      </el-row>
    </div>
    <el-button type="primary" style="width: 120px;" v-on:click="getBanner">测试</el-button>
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        form: {
          name: '',
          phone: '',
          email: '',
          qq: '',
          content: '',
        },
        formInline: {
          user: '',
          region: ''
        }
      }
    },
    methods:{
      postMessage(){
        this.$axios.post('/api/message', {
            name: this.form.name,
            phone: this.form.phone,
            email: this.form.email,
            qq: this.form.qq,
            content: this.form.content
          })
          .then(res=> {
            console.log(res);
            this.$message({
            	message: res.data.msg,
            	type: 'success',
            });
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getTopImage() {
      	this.$axios.get('/api/topimage/index', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getBanner(){
      	this.$axios.get('/api/banner', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});        
      },
      getIndexModule() {
      	this.$axios.get('/api/index/all', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getAboutMenu() {
      	this.$axios.get('/api/about/menu', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getAboutModule() {
      	this.$axios.get('/api/about/about', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getBusiness() {
      	this.$axios.get('/api/business', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getService() {
      	this.$axios.get('/api/service', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getProductType() {
      	this.$axios.get('/api/producttype', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getProduct() {
      	this.$axios.get('/api/product', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getRecommendProduct() {
      	this.$axios.get('/api/product/recommend', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getProductByTypeId() {
      	this.$axios.get('/api/product/type/3', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getProductById() {
      	this.$axios.get('/api/product/2020112608104965540568', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getCasesType() {
      	this.$axios.get('/api/casestype', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getCases() {
      	this.$axios.get('/api/cases', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getRecommendCases() {
      	this.$axios.get('/api/cases/recommend', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getCasesByTypeId() {
      	this.$axios.get('/api/cases/type/1', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
      getCasesById() {
      	this.$axios.get('/api/cases/2020110910341843310999', {
      			params: {

      			}
      		}).then(res => {
      			console.log(res.data);
      			if (res.data.code == '0') {
              this.$message({
              	message: res.data.msg,
              	type: 'success',
              });
      			} else {
      				this.$message({
      					message: res.data.msg,
      					type: 'error'
      				})
      			}
      		})
      		.catch(function(error) { // 请求失败处理
      			console.log(error);
      		});
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .message_wrap {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    border: 1px solid #000;
    border-radius: 10px;
  }

  .message_wrap .el-row .el-col {
    /* border: 1px solid red; */
    text-align: left;
  }

/* .message_wrap .el-row::after {
    display: block;
    content: '';
    clear: both;
    height: 0;
    overflow: hidden;
  } */

  .message_wrap .my-input {
    display: inline-block;
    width: calc(100% - 125px);
    margin-bottom: 10px;
    /* border: 1px solid red; */
  }

  .message_wrap .my-label {
    display: inline-block;
    width: 80px;
    /* border: 1px solid red; */

  }

  .message_wrap .title-en {
    font-family: ABold;
    font-size: 54px;
    color: #b09f89;
    opacity: .2;
    text-align: center;
  }

  .message_wrap .title {
    width: 200px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 8px;
    margin-bottom: 30px;
    border-bottom: 1px solid #000000;
    text-align: center;
    position: relative;
    top: -40px;
  }

  .message_wrap .star {
    color: #cdb86d;
    font-size: 12px;
    width: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue